import React from 'react';
import {
	CloseButton,
	updateHref,
	ClickLinkDataParamType,
} from '@rmc/webcx-web-libs';
import styles from './index.module.scss';
import { Image } from '../Image';

type BannerPropsType = {
	image: {
		src: string;
		link: string;
		alt?: string;
	};
	clickLinkData: ClickLinkDataParamType;
	onClose?: () => void;
	onImgLoad?: () => void;
	onClick: () => void;
	target?: string;
};

export function Banner({
	image,
	clickLinkData,
	onClose,
	onImgLoad,
	onClick,
	target = '_blank',
}: BannerPropsType) {
	const rel = 'noopener noreferrer';
	return (
		<div className={styles.banner}>
			<CloseButton className={styles.closeButton} onClick={onClose} />
			<a
				rel={rel}
				href={updateHref(clickLinkData, image.link)}
				className={styles.bannerLink}
				target={target}
				onClick={onClick}
				onAuxClick={onClick}
			>
				<Image onImgLoad={onImgLoad} className={styles.image} {...image} />
			</a>
		</div>
	);
}
